module.exports = __webpack_public_path__ + "static/vierseleer3-138aacc8e6516dfcdfb5ebf512d0943e.jpg";